import React, { Fragment, useRef, useState } from 'react';
import { BrandedHeader } from '@checkout-s/BrandedHeader';
import { useSelector, useDispatch } from 'react-redux';
import { loginPage, logout } from "@checkout/actions/auth";
import { getEmail, getInitials, isAuthorizedAsUser } from "@checkout/selectors/auth";
import Button from '@checkout-s/Button';
import clsx from 'clsx';
import Translation from '@checkout-s/Translation';
import SelectLanguage from './SelectLanguage';
import { getNumItemsInCart } from '@checkout-b/checkout/selectors/cart';
import { secondsTohhmmss } from '@checkout-b/helpers/time';
import { navigate } from '../../checkout/helpers/navigationService';
import { hasReservation, reservationCompleted } from '@checkout-b/checkout/selectors/ui';
import { setCheckoutOverlay } from '@checkout/actions/ui';

export const AccountAction = () => {
  const dispatch = useDispatch();

  const initials = useSelector(getInitials);
  const email = useSelector(getEmail);

  const dropdownRef = useRef();

  const [isDropdownVisible, setIsDropdownVisible] = useState(false);

  const showDropdown = () => {
    setIsDropdownVisible(true);
    document.addEventListener('mousedown', onClickOutside);
  };

  const hideDropdown = () => {
    setIsDropdownVisible(false);
    document.removeEventListener('mousedown', onClickOutside);
  };

  const onClickOutside = (e) => {
    if (!dropdownRef.current) return;

    if (!dropdownRef.current.contains(e.target)) {
      hideDropdown();
    }
  };

  const isInOrgListingWindow = () => window.parent !== window && window.parent.document.body.id.includes('org-listing');

  return (
    <div className="account__action-wrapper">
      <button className="account__action" onClick={showDropdown}>
        {initials}
      </button>
      <ul ref={dropdownRef} className={clsx('account__dropdown', isDropdownVisible && 'visible')}>
        {email && (
          <>
            <li className="dropdown__item">
              <span className="dropdown__email">{email}</span>
            </li>
            <hr/>
          </>
        )}
        <li className="dropdown__item">
          <Button className="button--clear logout" onClick={() => dispatch(logout(!isInOrgListingWindow()))}>
            <Translation>{'checkout__logout'}</Translation>
          </Button>
        </li>
      </ul>
    </div>
  );
};

export const ListingBrandedHeader = () => {
  const isLoggedIn = useSelector(isAuthorizedAsUser);
  const dispatch = useDispatch();
  const timeRemaining = useSelector(state => state.reservation.time_remaining);
  const itemCount = useSelector(getNumItemsInCart);
  const isReservationExist = useSelector(hasReservation);
  const isReservationCompleted = useSelector(reservationCompleted);
  const token = useSelector(state => state.reservation.token);

  const cartAllowed = isReservationExist && !isReservationCompleted;

  const showCart = () => {
    if (cartAllowed) {
      dispatch(setCheckoutOverlay(true));
      navigate(`/cart/${ token }`);
      window.scrollTo(0, 0);
    }
  }

  return (
    <BrandedHeader>
      <BrandedHeader.DefaultHeaderLeft />
      <BrandedHeader.HeaderRight>
        <div className="listing__branded-header__content">
          <SelectLanguage className="select-language--brander-header" />
          {!!timeRemaining && (
            <div className="header__timer">
              <i className="icon-clock" />
              <span className="header__timer-time" aria-live='polite'>
                {secondsTohhmmss(timeRemaining)}
              </span>
            </div>
          )}
          <Fragment>
            {!isLoggedIn &&
              <Button className="button--clear" onClick={() => dispatch(loginPage())}>
                <Translation>{'checkout__sign_in'}</Translation>
              </Button>}
            {isLoggedIn && <AccountAction />}
          </Fragment>
          <button className="button--clear header__cart" disabled={!cartAllowed} onClick={showCart}>
            <i className="icon-shopping_cart" />
            {+itemCount > 0 && (
              <span className="header__cart-count">
                {itemCount}
              </span>
            )}
          </button>
        </div>
      </BrandedHeader.HeaderRight>
    </BrandedHeader>
  );
};
